import React, { useState } from 'react';
import { IntegrationControllerBaseConfig } from '../../../base';
import { ThreadDetailController } from './integrationDetailInterface';
import { ThreadDetailViewProps } from './integrationDetailProps';

export function createThreadDetailController(
    config: IntegrationControllerBaseConfig
): ThreadDetailController {
    const {
        controller: {
            thread: { detail: threadController },
            createAction: createActionController,
        },
    } = config;

    const callController = createActionController({
        id: 'call',
    });

    return {
        useProps(context, item, props): ThreadDetailViewProps {
            const [activeTab, setActiveTab] = useState<'messages' | 'files'>('messages');
            const [isMenuOpen, setIsMenuOpen] = useState(false);

            const thread = threadController.useProps(context, item.thread, {
                messagesContainerRef: props.messagesContainerRef,
                onCall: props.onCall,
                composer: props.composer,
            });

            return {
                common: {
                    more: {
                        isOpen: isMenuOpen,
                        onOpen: () => setIsMenuOpen(true),
                        onClose: () => setIsMenuOpen(false),
                        items: [
                            {
                                id: 'view-profile',
                                label: 'View Profile',
                                onClick: () => console.log('View Profile'),
                            },
                            {
                                id: 'mute',
                                label: 'Mute Conversation',
                                onClick: () => console.log('Mute'),
                            },
                            {
                                id: 'search',
                                label: 'Search in Conversation',
                                onClick: () => console.log('Search'),
                            },
                            {
                                id: 'delete',
                                label: 'Delete Conversation',
                                onClick: () => console.log('Delete'),
                                colorScheme: 'red',
                            },
                        ],
                    },
                    header: {
                        person: {
                            name: item.definition.display_name || 'Agent',
                            avatar: 'SJ',
                            isOnline: item.integration?.status === 'active',
                        },
                        tabs: {
                            active: activeTab,
                            onChange: setActiveTab,
                        },
                    },
                    hero: {
                        title: `This conversation is just between @${item.definition.display_name || 'Agent'} and you.`,
                        description: `Check out their profile to learn more about them.`,
                        actions: [
                            {
                                id: 'view-profile',
                                label: 'View Profile',
                                onClick: () => console.log('View Profile clicked'),
                                variant: 'secondary' as const,
                            },
                        ],
                    },
                    thread: thread,
                    call: {
                        overlay: {
                            isOpen: props.disclosure.request.isOpen,
                            onClose: props.disclosure.request.onClose,
                            item: {
                                integration: item.integration,
                                thread: item.thread.thread,
                            },
                            async onEnd(call) {
                                return props.onCallEnd(call);
                            },
                        },
                    },
                },
            };
        },
    };
}
